import axios from "."

export default {
  startChatroom,
  fetchChatrooms,
  deleteChatroom,
  fetchBulkSendMetadata
}

async function startChatroom(user_id, member_id) {
  const response = await axios.post("/api/chatrooms", {
    user_id: user_id?.toString(),
    member_id: member_id?.toString(),
  })

  return response.data
}

async function deleteChatroom(chatroom_id) {
  const response = await axios.delete(`/api/chatrooms/${chatroom_id}`)
  return response.data
}

async function fetchChatrooms({ user_id, chatroomsFilter, page, limit, query }) {
  let url = `/api/chatrooms/user/${user_id}?chatroomsFilter=${chatroomsFilter}`
  if (page) url += `&page=${page}`
  if (limit) url += `&limit=${limit}`
  if (query) url += `&query=${query}`
  const response = await axios.get(url)
  return response.data
}

async function fetchBulkSendMetadata() {
  const response = await axios.get(`/api/chatrooms/bulk-send/metadata`)
  return response.data
}
